(function () {

    'use strict';

    angular.module('Services').service('AccountingInvoiceSurchargesTableService', AccountingInvoiceSurchargesTableService);

    AccountingInvoiceSurchargesTableService.$inject = ['AccountingService', 'TableLiteFactory', '$location'];

    function AccountingInvoiceSurchargesTableService(AccountingService, TableLiteFactory, $location) {
        return function (surcharges) {
            const tableData = {
                optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: 'Add New Surcharge',
                        tooltip: 'Add New Surcharge',
                        onClick: function () {
                            $location.path('/accounting/surcharges');
                        }
                    }]
                },
                config: {
                    noFooter: true,
                    noFilter: true,
                    noPagination: true,
                    noHeaders: false,
                    noItemsView: true,
                    noTableFooter: true,
                    colMinWidth: '135px'
                },
                headers: [
                    {
                        label: 'Pre-Saved Surcharges',
                        viewName: 'name'
                    },
                    {
                        label: 'Internal Name',
                        viewName: 'surchargeInternalName'
                    },
                    {
                        label: 'Service Code',
                        viewName: 'serviceCodeSurcharge'
                    },
                    {
                        label: 'Fee',
                        viewName: 'fee'
                    },
                    {
                        label: 'Margin',
                        viewName: 'margin'
                    },
                    {
                        label: 'Priority',
                        viewName: 'priority'
                    }
                ],
                data: []
            };
            const tableActions = new TableLiteFactory(tableData, {
                serviceCallback: function(callback) {
                    callback({ content: surcharges });
                },
                callbackFormat: ['success'],
                postRequestCallback: data => {
                    buildTableData(data);
                },
                postRequestErrorCallback: err => {
                    buildTableData(null);
                },
                defaultFilters: {
                    size: 20,
                    page: 0,
                    sort: 'id,desc'
                }
            });

            function buildTableData(data) {
                /*** START - Building of Data ***/

                tableActions.initializeTableData(data);
                if (!data)
                    return null;
                angular.forEach(data.content, function (surcharge) {
                    tableData.data.push(surcharge);
                });
                /*** END - Building of Data ***/
            }

            this.tableData = tableData;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/AccountingInvoiceSurchargesTableService.js